import {
  EnvironmentProviders,
  isDevMode,
  makeEnvironmentProviders
} from '@angular/core';
import {
  DEFAULT_ROUTER_FEATURENAME,
  RouterState,
  provideRouterStore,
  routerReducer
} from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideStoreApi } from 'ngrx-rtk-query';
import { authApi } from './api/cohrex/endpoints/auth';
import { customerApi } from './api/cohrex/endpoints/customers';
import { dashboardApi } from './api/cohrex/endpoints/dashboard';
import { mediaApi } from './api/cohrex/endpoints/media';
import { profileApi } from './api/cohrex/endpoints/profiles';
import { roleApi } from './api/cohrex/endpoints/roles';
import { tenantApi } from './api/cohrex/endpoints/tenants';
import { testApi } from './api/cohrex/endpoints/tests';
import { userApi } from './api/cohrex/endpoints/users';
import { inviteApi } from './api/cohrex/endpoints/invites';

export const provideCoreStore = (): EnvironmentProviders => {
  return makeEnvironmentProviders([
    provideStore({
      [DEFAULT_ROUTER_FEATURENAME]: routerReducer
    }),
    provideRouterStore({ routerState: RouterState.Minimal }),
    provideStoreDevtools({ logOnly: !isDevMode(), name: 'BMED Agenda App' }),
    provideStoreApi(authApi),
    provideStoreApi(userApi),
    provideStoreApi(profileApi),
    provideStoreApi(roleApi),
    provideStoreApi(tenantApi),
    provideStoreApi(customerApi),
    provideStoreApi(mediaApi),
    provideStoreApi(testApi),
    provideStoreApi(dashboardApi),
    provideStoreApi(inviteApi)
  ]);
};
